import React from "react";

interface EegConfigPageShellProps {
  children: React.ReactNode;
  className?: string;
}

const EegConfigPageShell: React.FC<EegConfigPageShellProps> = ({
  children,
  className = "",
}) => {
  const handleClickCapture = (event: React.MouseEvent<HTMLDivElement>) => {
    const target = event.target as HTMLElement | null;
    const button = target?.closest("button");
    if (!button || !event.currentTarget.contains(button)) return;
    if (!button.hasAttribute("type")) {
      button.setAttribute("type", "button");
    }
  };

  const handleSubmitCapture = (event: React.FormEvent<HTMLDivElement>) => {
    const form = event.target as HTMLFormElement | null;
    if (form?.dataset?.eegConfigAllowSubmit === "true") return;
    event.preventDefault();
  };

  return (
    <div
      className={`eeg-config-page ${className}`.trim()}
      onClickCapture={handleClickCapture}
      onSubmitCapture={handleSubmitCapture}
    >
      {children}
    </div>
  );
};

export default EegConfigPageShell;
